import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { INTERNAL_ADMIN_ROLES } from "@juristech/contracts/auth/roles.constants";

import { TokenService } from "../services/token.service";

export const authGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const token = tokenService.getAccessToken();

  if (!token || tokenService.isTokenExpired()) {
    tokenService.clearTokens();
    router.navigate(["/login"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  const payload = tokenService.decodeToken();
  if (!payload) {
    tokenService.clearTokens();
    router.navigate(["/login"]);
    return false;
  }

  const userRoles: string[] = payload.roles || [];
  if (
    !userRoles.some((r) =>
      INTERNAL_ADMIN_ROLES.includes(r as (typeof INTERNAL_ADMIN_ROLES)[number]),
    )
  ) {
    tokenService.clearTokens();
    router.navigate(["/login"]);
    return false;
  }

  return true;
};
